import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PlanningViewsResults } from '@src/suite/common/data-models/navigation/planning-views-results';
import { NavigationDirection } from '@src/suite/common/enums/navigation-direction';
import { ViewStateRecordsAlias } from '@src/suite/common/services/layout-state';

export const WireActions = createActionGroup({
    source: 'Wire',
    events: {
        'Add wire': props<StorytellingWireRecord>(),
        'Remove wire': props<StorytellingWireRecord>(),
        'Search Wires': props<{ vs: ViewStateRecordsAlias }>(),
        'Define wire comparators': emptyProps(),
        'Open Image': props<{ image: string }>(),
        'Open new topic from wire': props<{ topic: StorytellingTopicRecord }>(),
        'Navigate To Wire': props<{ currentNodeUuid: string; direction?: NavigationDirection }>(),
        'Navigate To Image': props<{ currentImage: string; direction?: NavigationDirection }>(),
        Loading: props<{ isLoading: boolean }>(),
        'Open Attach To Dialog': props<{ wire: StorytellingWireRecord }>(),
        'Set current topic view state': props<{ viewState: ViewStateRecordsAlias }>(),
    },
});

export const WireApiActions = createActionGroup({
    source: 'Wire API',
    events: {
        'Start polling': props<{ interval: number }>(),
        'Stop polling': props<{ restart: boolean; vs?: ViewStateRecordsAlias; interval?: number }>(),
        'Load wires success': props<{ wires: Array<StorytellingWireRecord> }>(),
        'Load topics success': props<{ topics: Map<string, StorytellingTopicRecord> }>(),
        'Load wires error': props<{ error: string }>(),
        'Create Discover Item': props<{ topic: StorytellingTopicRecord; wire: StorytellingWireRecord; createAndNext?: boolean }>(),
        'Create Discover Item Success': props<{ topic: StorytellingTopicRecord; discoverItem: StorytellingRecord; createAndNext?: boolean }>(),
        'Create Discover Item Error': props<{ error: string }>(),
        'Create Topic': props<{ wire: StorytellingWireRecord }>(),
        'Attach Item': props<{ wire: StorytellingWireRecord; topic: StorytellingTopicRecord }>(),
        'Attach Item Success': emptyProps(),
        'Topic Search Term': props<{ searchTerm: string }>(),
        'Reload topics based on current view state': props<{ viewState: ViewStateRecordsAlias }>(),
        'Load topic view states': emptyProps(),
        'Load topic view states success': props<{ data: PlanningViewsResults }>(),
    },
});
